import uploadAudioData from "./uploadAudioData";
import uploadFile from "./uploadFile";

export default function uploadData(props) {
  if (props.media.type === "AUDIO") return uploadAudioData(props);
  return uploadFile(props);
}
